module.exports = __webpack_public_path__ + "static/media/FinderIcon.3b4cf039.svg";